import  { useState } from "react";
import "./ThreeStateToggle.css";

export default function ThreeStateToggle({
  options = [
    { id: "low", label: "کم", subtitle: "صرفه‌جویی" },
    { id: "auto", label: "خودکار", subtitle: "پیشنهاد سیستم" },
    { id: "high", label: "زیاد", subtitle: "قدرت کامل" },
  ],
  value,
  defaultValue = options[1].id,
  onChange,
}) {
  const isControlled = value !== undefined;
  const [selected, setSelected] = useState(defaultValue);

  const current = isControlled ? value : selected;

  const handleChange = (id) => {
    if (!isControlled) setSelected(id);
    onChange?.(id);
  };

  return (
    <div className="three-toggle d-flex border rounded-pill overflow-hidden">
      {options.map((opt) => {
        const active = opt.id === current;
        return (
          <button
            key={opt.id}
            type="button"
            className={`flex-fill btn-toggle py-2 px-3 text-center ${
              active ? "active" : ""
            }`}
            onClick={() => handleChange(opt.id)}
          >
            <div className="fw-bold">{opt.label}</div>
            {opt.subtitle && (
              <div className="small opacity-75">{opt.subtitle}</div>
            )}
          </button>
        );
      })}
    </div>
  );
}
